import { enumKeysToArray } from '@/utils/enum'
import { makeServicesTypes } from '@/core/container/makeServicesTypes'

enum SERVICES {
  FacebookConfigRepository,
  FacebookConfigService,

  FacebookPageRepository,
  FacebookPageService,

  FacebookColumnService,

  ChatFacebookResolver,

  SelectFacebookPageFieldBuilderService,

  FacebookSenderChannelProvider,
}

export type FacebookServices = keyof typeof SERVICES

export const FACEBOOK_SERVICE_TYPES: Record<FacebookServices, symbol> = makeServicesTypes<FacebookServices>(
  enumKeysToArray<FacebookServices>(SERVICES),
)
